import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import OverlapSection from 'Component/OverlapSection/OverlapSection';
import TwoColumnSection from 'Component/TwoColumnSection/TwoColumnSection';
import CtaSection from 'Component/CtaSection/CtaSection';
import Table from 'Component/Table/Table';

import IconsData from 'IconsData/NPS.json';
import { NPSFeatured } from 'TwoColumnData/NPSFeatured.js';
import TwoColumnData from 'TwoColumnData/NPS.json';
import { NPSData } from 'TableData/NPS.js';

const NPS = () => {
	const images = useStaticQuery(IMAGES_QUERY);

	return (
		<Layout>
			<SEO title="National Pension Scheme" description="" />
			<Hero
				heading="National Pension Scheme"
				iconsData={IconsData}
				breadcrumbs={[
					{
						text: 'Invest',
						link: '#',
					},
					{
						text: 'National Pension Scheme',
						link: '#',
					},
				]}
				ctaFormText="Interested in investing in National Pension Scheme?"
				customClass="bgNps"
			/>
			<OverlapSection
				heading="What is NPS or National Pension Scheme?"
				description="National Pension Scheme is an all-round retirement planning scheme that ensures a fixed income after retirement while also retaining various tax benefits thus killing two birds with one stone. The pool of contributions from subscribers of the National Pension Scheme is invested into various market linked instruments like equities and debts. The amount of your pension is decided on the basis of the performance of your NPS funds. When you enter retirement stage, you can purchase an annuity [monthly pension] using your accumulated corpus. National Pension Scheme is regulated by the Pension Fund Regulatory and Development Authority [PFRDA]."
			/>
			<TwoColumnSection
				data={NPSFeatured}
				images={images}
				btnText="Get Started with NPS"
				customClass="twoColumnNps"
			/>
			<CtaSection
				heading="Look forward to a comfortable retirement. Invest in NPS now!"
				aboutText="Prefer to enjoy returns on your investment earlier?"
				aboutTextLink="Then explore Direct Plans of Mutual Funds."
				aboutTextLinkUrl="/direct-mutual-funds"
			/>
			<TwoColumnSection
				heading="Why Invest In National Pension Scheme?"
				data={TwoColumnData}
				images={images}
				customClass="nps"
			/>
			<Table
				heading="Tax Benefits for NPS"
				tableHeading={['NPS Account', 'Tax Benefit', 'Tax Treatment']}
				data={NPSData}
			/>
		</Layout>
	);
};

export default NPS;

const IMAGES_QUERY = graphql`
	{
		# Two Section Column Images
		howToInvest: file(
			relativePath: { eq: "nps/two-column/how-to-invest.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		securedIncome: file(
			relativePath: { eq: "nps/two-column/secured-income.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		goodReturns: file(relativePath: { eq: "nps/two-column/good-returns.png" }) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		taxBenefits: file(relativePath: { eq: "nps/two-column/tax-benefits.png" }) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;
